import React from "react";
import "./UaeReq.css";
import UaeReqMain from "./UaeReqMain";

const UaeReq = () => {
  return (
    <div className="uaeReqContainer">
      <UaeReqMain />
    </div>
  );
};

export default UaeReq;
